import script from "./PaysView.vue?vue&type=script&setup=true&lang=js"
export * from "./PaysView.vue?vue&type=script&setup=true&lang=js"

import "./PaysView.vue?vue&type=style&index=0&id=7de33bf0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7de33bf0"]])

export default __exports__